import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/app/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Optional: Add interceptors for auth, error handling, etc.
// instance.interceptors.request.use(...)
// instance.interceptors.response.use(...)

export default instance;
